module.exports = __webpack_public_path__ + "img/openAi.9f7c7e71.png";